/**
 * Labstep
 *
 * @module components/Folder/Action/CreateSub
 * @desc Create Sub Folder Action
 */

import { CanCreate } from 'labstep-web/components/Entity/Can';
import FolderFormCreateSub from 'labstep-web/components/Folder/Form/CreateSub';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FolderActionCreateSubProps } from './types';

export const FolderActionCreateSub: React.FC<
  FolderActionCreateSubProps
> = ({ folder, folderType, actionComponentProps }) => (
  <CanCreate entityName={`folder_${folderType}`}>
    <ModalDefault
      header="Add Sub-collection(s)"
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          type="option"
          onClick={toggleModal}
          icon={ICONS.folder.primary}
          text="Add Sub-collection(s)"
          {...actionComponentProps}
        />
      )}
      content={({ toggleModal }) => (
        <FolderFormCreateSub
          autoFocus
          body={{ type: folderType, outer_folder_id: folder.guid }}
          options={{ onSuccess: toggleModal }}
        />
      )}
    />
  </CanCreate>
);
